import { Badge } from "antd";

const RecordsUser = ({ user, width, height, qty, vid }) => {
  return<div style={{width, height}} className="records-user">
    <img src={vid ? "/images/door.svg" : "/images/user.svg"} alt="user" className="records-user-img"/>
    <div className="records-user-data">
      <div  className="records-user-name">{user.name} <Badge color="blue" count={qty} /></div>
      <div>{user.userName}</div>
    </div>
  </div>
}

export default RecordsUser;